import React from 'react';
import { GroupElevesPicker } from '@teetsh/app/src/containers/CarnetsDeNotes/components/GroupElevesPicker';
import { useField } from 'react-final-form';
import { Note } from '@teetsh/app/src/containers/CarnetsDeNotes/types/carnetsDeNotes';
import { useDeleteNotesWarningModal } from '@teetsh/app/src/containers/CarnetsDeNotes/Evaluations/DeleteNotesWarningModal/useDeleteNotesWarningModal';
import { updateNotesWithNewGroup } from '@teetsh/app/src/containers/CarnetsDeNotes/Evaluations/updateNotesWithNewGroup';
import { Eleve } from '@teetsh/app/src/types/eleves';
import { NotationSystem } from '@teetsh/app/src/types/notationSystem';

interface Props {
  value: string[];
  onChange: (v: string[]) => void;
  options: string[];
  evaluationId: string;
  eleves: Eleve[];
  notationSystem?: NotationSystem;
}

export function GroupElevesPickerForm(props: Props) {
  const { value, onChange, options, eleves, evaluationId, notationSystem } = props;
  const notesField = useField<Note[]>('notes');
  const { open } = useDeleteNotesWarningModal();
  const { input: inputNotes } = notesField;
  return (
    <div>
      <GroupElevesPicker
        options={options}
        value={value || []}
        onChange={v => {
          const { newNotes, areSomeNotesDeleted } = updateNotesWithNewGroup(
            inputNotes.value,
            eleves,
            v,
            evaluationId,
            notationSystem,
          );
          if (areSomeNotesDeleted) {
            const callback = () => {
              inputNotes.onChange(newNotes);
              onChange(v);
            };
            open({ callback });
          } else {
            inputNotes.onChange(newNotes);
            onChange(v);
          }
        }}
      />
    </div>
  );
}
